export const educationOptions = [
  {
    label: 'common.education.highSchool',
    key: 'High School',
    value: 'High School',
  },
  {
    label: 'common.education.associate',
    key: 'Associate',
    value: 'Associate',
  },
  {
    label: 'common.education.bachelor',
    key: 'Bachelor\'s',
    value: 'Bachelor\'s',
  },
  {
    label: 'common.education.master',
    key: 'Master\'s',
    value: 'Master\'s',
  },
  {
    label: 'common.education.doctorate',
    key: 'Doctorate',
    value: 'Doctorate',
  },
  {
    label: 'common.education.professional',
    key: 'Professional',
    value: 'Professional',
  },
];

export const responsibilitiesOptions = [
  {
    label: 'common.jobResponsibilities.teaching',
    key: 'teachingFlag',
  },
  {
    label: 'common.jobResponsibilities.athleticCoaching',
    key: 'coachingFlag',
  },
  {
    label: 'common.jobResponsibilities.counseling',
    key: 'counselingFlag',
  },
  {
    label: 'common.jobResponsibilities.testPreparation',
    key: 'testPrepFlag',
  },
  {
    label: 'common.jobResponsibilities.academicAdmin',
    key: 'academicAdminFlag',
  },
  {
    label: 'common.jobResponsibilities.clericalSupport',
    key: 'clericalSupportFlag',
  },
  {
    label: 'common.jobResponsibilities.standardizedTesting',
    key: 'standardTestFlag',
  },
];
